export function getMaxValueOfTag(
  object: Record<string, Record<string, Record<string, number>>>,
) {
  return Object.fromEntries(
    Object.keys(object || {})
      .map((tag) => {
        const maxKey = Object.keys(object[tag] || {}).reduce((max, current) =>
          object[tag][current] > object[tag][max] ? current : max,
        );

        if (object[tag][maxKey] === 0) {
          return null;
        }

        return [tag, maxKey];
      })
      .filter(Boolean),
  );
}
